import { PricingTabAddPriceModalAmountField } from "../AmountField";

export const PricingTabAddPriceModalFieldsOneTime = () => (
  <PricingTabAddPriceModalAmountField name="amount" labelKey="price" />
);
